import React from 'react';
import { TTopCategory } from 'data';
import { FilterListItem } from '../filter-list-item';

import { FilterList } from './styles';

type FilterColumnProps = {
	topCategories: TTopCategory[];
	selectedFilterItems: number[];
	start: number;
	end: number;
	checkboxHandler: (categoryId: number) => void;
	className?: string;
	dataQa?: string;
};

export const FilterColumn = ({
	topCategories,
	selectedFilterItems,
	start,
	end,
	checkboxHandler,
	className = '',
	dataQa = '',
}: FilterColumnProps) => {
	const renderedTopCategories = topCategories.slice(start, end);

	return (
		<FilterList className={className} data-qa={dataQa}>
			{renderedTopCategories.map(({ topCategoryId, topCategoryName }) => {
				const checked = selectedFilterItems.includes(topCategoryId);
				return (
					<FilterListItem
						topCategoryId={topCategoryId}
						topCategoryName={topCategoryName}
						onClickHandler={checkboxHandler}
						checked={checked}
						key={`filter-list-item-${topCategoryId}`}
					/>
				);
			})}
		</FilterList>
	);
};
